import React from "react";
import { useStore } from "@/context/StoreContext";

function Shell({ title, sub, children }) {
  return (
    <div className="max-w-3xl mx-auto px-6 py-14">
      <h1 className="font-serif text-4xl sm:text-5xl">{title}</h1>
      {sub && <p className="text-sharoa-muted mt-2">{sub}</p>}
      <div className="mt-8 prose-sharoa text-sharoa-charcoal/85 leading-relaxed space-y-4 text-sm">{children}</div>
    </div>
  );
}

export function About() {
  return (
    <Shell title="About SHAROA" sub="Made for your kind of beautiful.">
      <p>SHAROA is a contemporary women's fashion label created for effortless femininity. From soft knitted textures to modern western silhouettes, every piece is designed to make everyday dressing feel beautiful.</p>
      <p>We believe modern femininity is worn, not performed — soft, confident and entirely your own. Each SHAROA edit is thoughtfully designed, responsibly made and built to become a favourite in your wardrobe.</p>
      <p className="font-serif text-2xl text-sharoa-rose">Modern femininity, beautifully worn ♡</p>
    </Shell>
  );
}

export function ReturnPolicy() {
  return (
    <Shell title="Return Policy" sub="7-Day Returns ♡">
      <p>Eligible SHAROA products can be requested for return within <strong>7 days of delivery</strong>, subject to this Return Policy.</p>
      <ul className="list-disc pl-5 space-y-1.5">
        <li>Request within 7 days of delivery.</li>
        <li>Product must be unused/unworn where applicable.</li>
        <li>Original tags retained.</li>
        <li>Original packaging retained where applicable.</li>
        <li>Product must satisfy condition requirements on quality check.</li>
        <li>Certain customized, hygiene-sensitive or explicitly non-returnable (Final Sale) products are excluded.</li>
      </ul>
      <p>The return window begins from the actual delivery timestamp. Non-returnable products are clearly marked as <strong>Final Sale</strong> before purchase.</p>
      <p><strong>Refunds:</strong> For online-paid orders, approved refunds are processed to the original payment method. For Cash on Delivery orders, refunds are processed to verified bank/UPI details.</p>
    </Shell>
  );
}

export function ShippingPolicy() {
  return (
    <Shell title="Shipping" sub="From our studio to your doorstep ♡">
      <p>We ship across India via trusted courier partners. Standard delivery takes 4–6 business days; express delivery 2–3 business days.</p>
      <p>Enjoy FREE shipping on orders above ₹999. You can track your order anytime on our Track Order page.</p>
    </Shell>
  );
}

export function SizeGuide() {
  const { settings } = useStore();
  const chart = settings?.size_chart || {};
  return (
    <Shell title="Size Guide" sub="Find your perfect fit ♡">
      <table className="w-full text-sm border border-sharoa-line">
        <thead className="bg-sharoa-ivory"><tr><th className="py-2.5 px-4 text-left">Size</th><th className="py-2.5 px-4 text-left">Bust</th></tr></thead>
        <tbody>{Object.entries(chart).map(([k, v]) => <tr key={k} className="border-t border-sharoa-line"><td className="py-2.5 px-4 font-medium">{k}</td><td className="py-2.5 px-4">{v}</td></tr>)}</tbody>
      </table>
    </Shell>
  );
}

export function FAQ() {
  const faqs = [
    ["How long does delivery take?", "Standard delivery is 4–6 business days; express 2–3 days."],
    ["What is your return policy?", "Eligible items can be returned within 7 days of delivery. See our Return Policy."],
    ["Do you offer Cash on Delivery?", "Yes, COD is available on eligible orders."],
    ["How can I track my order?", "Visit our Track Order page with your order number and email or mobile."],
  ];
  return (
    <Shell title="FAQ" sub="Everything you need to know ♡">
      {faqs.map(([q, a]) => <div key={q} className="border-b border-sharoa-line pb-3"><p className="font-serif text-lg">{q}</p><p className="text-sharoa-muted mt-1">{a}</p></div>)}
    </Shell>
  );
}

export function Contact() {
  return (
    <Shell title="Contact Us" sub="We'd love to hear from you ♡">
      <p>Email us at <a href="mailto:hello@sharoa.com" className="text-sharoa-rose">hello@sharoa.com</a> or chat with us on WhatsApp using the button on the bottom-right.</p>
      <p>Follow us on Instagram <a href="https://instagram.com/sharoaofficial" target="_blank" rel="noreferrer" className="text-sharoa-rose">@sharoaofficial</a>.</p>
    </Shell>
  );
}
